export default {
  LESS_HUNDRED: "price_1LITtGBNojRG2LLANj8XovrP",
  HUNDRED_TO_TWO_HUNDRED_AND_HALF: "price_1LITtBBNojRG2LLA2waKB48g",
  TWO_HUNDRED_AND_HALF_TO_FIVE_HUNDRED: "price_1LITt1BNojRG2LLAQsimeLNv",
  FIVE_HUNDRED_TO_ONE_THOUSAND: "price_1LITswBNojRG2LLAtwYhvaJe",
  ONE_THOUSAND_TO_FIVE_THOUSAND: "price_1LITsrBNojRG2LLAPcuKuPh9",
  MORE_THAN_FIVE_THOUSAND: "price_1LITsmBNojRG2LLABopazewO",
  ALL: "price_1LITsgBNojRG2LLA8TL6fc6g",
}